import { ImageEntry } from '../content.types';
import { dataFor } from '../data';
import { useLanguage } from './use-content';

export interface UseImageContentResult {
  data?: ImageEntry;
  isLoading: boolean;
}

export function useImageContent(id?: string): UseImageContentResult {
  const language = useLanguage();
  const images = dataFor('images', language);
  const data = id ? images[id] : undefined;
  return { data, isLoading: false };
}
